module.exports = __webpack_public_path__ + "img/process.30702611.png";